import React, { useState } from "react";
import { styled } from "@mui/material/styles";

interface PrintDropdownProps {
  measurementId: string;
}

const DropdownContainer = styled("div")`
  position: relative;
  display: inline-block;
  margin-right: 16px;
  
  @media (max-width: 768px) {
    margin-right: 20px;
  }
`;

const DropdownButton = styled("button")`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffbb00;
  width: 156px; /* Aumentado 30% de 120px */
  padding: 8px 12px;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #ffbb00;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: #ffbb00;
    color: #ffffff;
  }

  &::after {
    content: "▼";
    font-size: 10px;
    margin-left: 8px;
  }
`;

const DropdownMenu = styled("div")<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #ffbb00;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  margin-top: 4px;
`;

const DropdownItem = styled("div")`
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f8f8f8;
    color: #ffbb00;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const PrintDropdown: React.FC<PrintDropdownProps> = ({ measurementId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option: string) => {
    setIsOpen(false);
    
    switch (option) {
      case "pdf":
        window.open(`/medicoes/print/${measurementId}`, "_blank", "noreferrer");
        break;
      case "thermal-graph":
        window.open(`/medicoes/thermal-graph/${measurementId}`, "_blank", "noreferrer");
        break;
      case "thermal-text":
        window.open(`/medicoes/thermal-text/${measurementId}`, "_blank", "noreferrer");
        break;
      default:
        break;
    }
  };

  // Fechar dropdown quando clicar fora
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest('[data-dropdown]')) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <DropdownContainer data-dropdown>
      <DropdownButton onClick={toggleDropdown}>
        Imprimir
      </DropdownButton>
      <DropdownMenu isOpen={isOpen}>
        <DropdownItem onClick={() => handleOptionClick("pdf")}>
          Download PDF
        </DropdownItem>
        <DropdownItem onClick={() => handleOptionClick("thermal-graph")}>
          Impressão Térmica Gráfico
        </DropdownItem>
        <DropdownItem onClick={() => handleOptionClick("thermal-text")}>
          Impressão Térmica Texto
        </DropdownItem>
      </DropdownMenu>
    </DropdownContainer>
  );
};

export default PrintDropdown;
